export const formatDate = (value: string) => {
  // value in format '2021-04-27T00:00:00.000Z'
  let result = value.substring(0, 10); // only date, e.g. '2021-04-27'

  // result need to be strings in format MM/DD/YYYY
  result =
    result.slice(5, 7) + '/' + result.slice(8, 10) + '/' + result.slice(0, 4);
  return result;
};
